import React from 'react';
import { Box } from '@mui/material';
import Image from '../../Image/Image';

const DEFAULT_ICON_SRC =
  'https://assets.askhippo.co.za/Icons/common/Union_Black.svg';

const LinkWithIconComponent = ({
  href,
  children,
  component,
  showIcon = true,
  sx = {},
  iconSrc = DEFAULT_ICON_SRC,
  iconAlt = 'Link icon',
  iconSize = '1rem',
  target,
  rel,
  onClick,
  ...rest
}) => {
  const normalizedHref =
    typeof href === 'string' ? href.trim() : href || undefined;
  const isLink = Boolean(normalizedHref);
  const shouldShowIcon = showIcon && isLink;
  const resolvedComponent = component || (isLink ? 'a' : 'span');

  return (
    <Box
      component={resolvedComponent}
      href={isLink ? normalizedHref : undefined}
      target={target}
      rel={rel}
      onClick={onClick}
      {...rest}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'pre-line',
        gap: '6px',
        maxWidth: '100%',
        color: 'inherit',
        textDecoration: 'none',
        verticalAlign: 'middle',
        cursor: isLink ? 'pointer' : 'default',
        '&:focus-visible': {
          outline: '2px solid currentColor',
          outlineOffset: '4px',
          borderRadius: '8px',
        },
        ...sx,
      }}
    >
      <Box component="span" sx={{ minWidth: 0 }}>
        {children}
      </Box>
      {shouldShowIcon && (
        <Image
          width={16}
          height={16}
          src={iconSrc}
          alt={iconAlt}
          sx={{
            width: iconSize,
            height: iconSize,
            flexShrink: 0,
          }}
        />
      )}
    </Box>
  );
};

export default LinkWithIconComponent;
